import React, { useState, useEffect } from "react";

import BarGraph from "./BarGraph";
import liracrypt from "../../../components/Liracrypt/liracrypt";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../components/ApiErrorComp/ApiErrorComp";

const DownTimeBarGraph = (props) => {
  const [data, setData] = useState(null);
  const [loginError, setLoginError] = useState(false);

  const fetchDowntimeData = () => {
    liracrypt
      .get("/linedash/tabs/ld/tab/downtime/hourly", {
        lid: props.selectedLid,
      })
      .then(({ data }) => {
        const fetchdata = data.data
          ? data.data.map((obj) => {
              return { ...obj, val: parseFloat(obj["val"].toFixed(2)) };
            })
          : [];

        setData(fetchdata);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (data === null) {
      fetchDowntimeData();
    }
  }, [data]);

  return (
    <>
      <SessionError visible={loginError} />
      <div>
        <BarGraph
          data={data}
          barkey="val"
          category="series"
          barColor={"#FFE600"}
          divId={"downTimeBar"}
        />
      </div>
    </>
  );
};

export default DownTimeBarGraph;
